import fluorescentImg from "assets/effectImages/fluorescent.png";
import marbleImg from "assets/effectImages/marble.png";
import metallicPearlescentImg from "assets/effectImages/metallic-pearlescent.png";
import opaqueImg from "assets/effectImages/opaque.png";
import phosphorescentImg from "assets/effectImages/phosphorescent.png";
import translucentImg from "assets/effectImages/translucent.png";
import transparentImg from "assets/effectImages/transparent.png";

interface EffectUiConfig {
  image: string;
  accentColor: string;
}

export const EFFECT_UI_CONFIG: Record<string, EffectUiConfig> = {
  MARBLE: { image: marbleImg, accentColor: "#ff7f41" },
  METALLIC_OR_PEARLESCENT: {
    image: metallicPearlescentImg,
    accentColor: "#999",
  },
  FLUORESCENT: { image: fluorescentImg, accentColor: "#4ccfa4" },
  PHOSPHORESCENT: { image: phosphorescentImg, accentColor: "#26c591" },
  OPAQUE: { image: opaqueImg, accentColor: "#999" },
  TRANSPARENT: { image: transparentImg, accentColor: "#009fe4" },
  TRANSLUCENT: { image: translucentImg, accentColor: "#a488d8" },
};
